import { useFeatureFlag } from 'hooks/useFeatureFlag';
import Home from './Home';
import RedesignHome from './RedesignHome';

const HomeSwitcher = () => {
  const isRedesign = useFeatureFlag('enable-homepage-redesign');
  return isRedesign ? <RedesignHome /> : <Home />;
};

export default HomeSwitcher;
